import React, { useEffect, useState, useContext } from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  GetPostMethodData,
  DecryptAESdata,
} from "../../../../provider/ServiceProvider";
import animation from "../../../../images/jm-animation.gif";
import URLstateContext from "../../../../provider/CommonContext";
import { GetMethodData } from "../../../../provider/ServiceProvider";
import DocumentGalleryInner from "./DocumentGalleryInner";
import { Link } from "react-router-dom";
import "./Document.css"; // Ensure this import is correct documentgallery commonprovider file edit selection finq communicationhub src components finq finqsection documentgal

function DocumentGallery() {
  const [data, setData] = useState([]);
  const [loadingshow, setLoadingshow] = useState(true);
  const [show, setShow] = useState(false);
  const [showInnerComponent, setShowInnerComponent] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [fetchDatavdo, setFetchDatavdo] = useState([]);
  const { BaseURL } = useContext(URLstateContext);

  useEffect(() => {
    fetchMarketOutlookData();
  }, [BaseURL]);

  const clickyoutube = (event) => {
    setShow(true);
    fetchVideoLink(event);
  };

  const fetchMarketOutlookData = () => {
    GetMethodData(BaseURL + "GetDocumentGallery", {}).then((responseData) => {
      if (responseData.data != null && responseData.data.length > 0) {
        setData(DecryptAESdata(responseData.data));
        // console.log(DecryptAESdata(responseData.data));
        setLoadingshow(false);
      } else {
        setData([]);
        setLoadingshow(false);
      }
    });
  };

  const fetchVideoLink = (event) => {
    GetPostMethodData(BaseURL + "GetVideoLink", {
      IVsrno: event,
    }).then((data) => {
      if (data.data != null && data.data.length > 0) {
        setFetchDatavdo(DecryptAESdata(data.data));
      }
    });
  };

  const handleShowInnerComponent = (document) => {
    setSelectedDocument(document);
    setShowInnerComponent(true);
  };

  const handleClosePopup = () => {
    setShow(false);
  };

  return (
    <>
      <Container>
        <section className="documents-section">
          <div className="container">
            {data && data.length === 0 && loadingshow === false ? (
              <h5 className="errormsgComNew">No Data Available !!!</h5>
            ) : (
              <div className="documents-grid-container">
                {data &&
                  data.map((document) => (
                    <div
                      key={document.id}
                      className="documents-card"
                      style={{ width: "100%", overflow: "hidden" }}
                    >
                      <img
                        style={{ width: "100%", height: "auto" }}
                        src={`/CMS/insights/${document.ThumbnailImage}`}
                        alt={document.CategoryName}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = ""; // Placeholder handling in CSS
                        }}
                      />
                      {document.ThumbnailImage === "" && (
                        <div className="fallback-image">No Image Available</div>
                      )}
                      <div className="card-content">
                        <h3>{document.CategoryName}</h3>
                        <Link
                        className="read-more-link"
                          to={`/Insights/DocumentGallery/${document.CategoryName.replace(
                            /\s+/g,
                            "-"
                          )}/${document.CategoryID}`}
                        >
                          Read More
                        </Link>
                      </div>
                    </div>
                  ))}
              </div>
            )}
            {loadingshow && (
              <div className="textcentervertex" role="status" aria-live="polite" aria-busy="true">
                <img src={animation} alt="" aria-hidden="true" />
                <div className="model_popup">Please Wait...</div>
              </div>
            )}
          </div>
        </section>
      </Container>
    </>
  );
}

export default DocumentGallery;

